export default {
    ImportNew: 'Nhập khẩu thêm mới',
    DragDropFileOrClickHereToImport: 'Kéo thả tệp vào đây hoặc nhấn để chọn tệp',
    FormatAndMaxSizeImportFile: 'Hỗ trợ định dạng *.xls, *.xlsx và kích thước tối đa 5 MB',
    OtherFile: 'Đổi tệp khác',
    ChooseSheetAndRowHeader: 'Bạn vui lòng chọn sheet dữ liệu muốn nhập khẩu và dòng tiêu đề của sheet đó.',
    ImportSheet: 'Sheet nhập khẩu',
    RowHeader: 'Dòng tiêu đề',
    TotalRecord: 'Số bản ghi',
    ValidRecord: 'Hợp lệ',
    InvalidRecord: 'Không hợp lệ',
    DownloadValidateFile: 'Bạn có thể tải tệp kết quả nhập khẩu gồm các bản ghi không hợp lệ để chỉnh sửa và nhập khẩu lại. Hoặc tiếp tục nhập khẩu những bản ghi hợp lệ.',
    DownloadInvalidFile: 'Tải những bản ghi không hợp lệ',
    DownloadValidAndInValidFile: 'Tải tất cả bản ghi',
    ChooseTemplateFile: 'Chọn tệp nhập khẩu',
    MappingColumn: 'Ghép trường thông tin',
    Import: 'Nhập khẩu',
    MaxSizeImportFile: 'Tệp vượt quá dung lượng cho phép',
    ErrorFormatImportFile: 'Tệp không đúng định dạng',
    ImportSuccess: 'Nhập khẩu thành công',
    ErrorMappingColumn: 'Trường thông tin bắt buộc khi ghép không được để trống',

    ImportDescription:
    {
        Task: 'Nhập khẩu thêm mới những công việc có kế hoạch trước của đơn vị',
        User: 'Nhập khẩu thêm mới đầy đủ thông tin người dùng trong đơn vị'
    },

    ImportType: {
        Task: 'Nhập khẩu công việc',
        User: 'Nhập khẩu người dùng',
    },

    ImportFileName: {
        Task: 'Mau_Nhap_Khau_Cong_viec.xlsx',
        User: 'Mau_Nhap_Khau_Nguoi_Dung.xlsx',
    }
}